const VehicleAction = Object.freeze({
  FuelCutOff: 'fuel_cut_off',
  FuelRestore: 'fuel_restore'
})

export default VehicleAction



// WEBPACK FOOTER //
// ./src/constants/vehicle_action.js